import {styled, Logo} from "@reside/ui";

export const NavLogo = styled(Logo)`
  width: auto;
  height: 32px;
  margin: 0px;
`;
